!function(){"use strict";customElements.get("quantity-counter")||customElements.define("quantity-counter",class extends HTMLElement{constructor(){super()}connectedCallback(){this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.buttonClickEvent=this.onButtonClick.bind(this),this.onQuantityChangeEvent=this.onQuantityChange.bind(this),this.input.addEventListener("change",this.onQuantityChangeEvent),this.querySelectorAll("button").forEach((t=>t.addEventListener("click",this.buttonClickEvent)))}onButtonClick(t){t.preventDefault();const e=this.input.value,n="BUTTON"==t.target.nodeName?t.target:t.target.closest("button");"increase"===n.name&&this.input.stepUp(),"decrease"===n.name&&this.input.stepDown(),e!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}onQuantityChange(){"updates[]"==this.input.name&&this.updateCart()}updateCart(){""!==this.quantityValue&&this.dispatchEvent(new CustomEvent("theme:cart:update",{bubbles:!0,detail:{id:this.input.dataset.id,quantity:this.input.value}}))}})}();

/*
document.addEventListener('DOMContentLoaded', function () {

  // Hardcoded partner variant mapping
  // Format: "shopify_variant_id": "partner_variant_id"
  const partnerVariantMap = {
    55087172288899: 40078752776255,
    55087172321667: 40184343461951,
    55087173501315: 40184343429183,
    55093439922563: 40184720457791,
    55093439955331: 40184720556095,
    55093384216963: 40184725569599,
    55087461564803: 40184187125823,
    55093480915331: 40184720130111,
    55093518565763: 40184720261183,
    55158125953411: 40184716427327,
    55158044295555: 39436640747583,
    55158070739331: 39436640682047,
    55158044361091: 39436640714815,
    55158044426627: 39436640780351,
    55093568110979: 40184765481023,
    55093574566275: 40184765349951,
    55096839504259: 40184286314559,
    55096839537027: 40184758534207,
    55157907194243: 39637271543871,
    55157979316611: 39637638611007,
    55157987606915: 39637637988415,
    55157992784259: 39637637562431,
    55158006710659: 40184294113343,
    56445428597123: 40248182243391,
    56397607436675: 40184715247679,
    56445444227459: 40184252399679,
    55157744140675: 40078760116287,
    55157744173443: 39992336056383,
    55157744206211: 39992336023615,
    55157643051395: 40078760771647,
    55157681389955: 39992327340095,
    55157688926595: 39992327307327,
    55157698429315: 40078760149055,
    55157698462083: 39992333369407,
    55157698494851: 39992333336639,
    55156675150211: 40184718917695,
    55156675182979: 40184718852159,
    55156664500611: 40184718622783,
    55156654834051: 40184718491711,
    55101897277827: 39429861703743,
    55101897310595: 40078762606655,
    55101897343363: 40078762967103,
    55101897376131: 39429860622399,
    55101928800643: 39429861965887,
    55101928833411: 40078761820223,
    55101928866179: 39429861933119,
    55102102307203: 40078751268927,
    55101947380099: 40078750908479,
    55101947412867: 40078750875711,
    55101964845443: 39429862031423,
    55101964878211: 40078761656383,
    55101964910979: 39429861998655,
    55098510737795: 39728896475199,
    55098510770563: 39429859737663,
    55101751361923: 40184330354751,
    55101751394691: 40184330420287,
    55101751427459: 40184330485823,
    55101751460227: 40184330551359,
    55101751492995: 40184330321983,
    55101751525763: 40184330387519,
    55101751558531: 40184330453055,
    55101751591299: 40184330518591,
    55101609935235: 40184300929087,
    55101610000771: 40184300994623,
    55101669048707: 40184301060159,
    55101610033539: 39429850759231,
    55101610066307: 39429850824767,
    55101610099075: 39429850890303,
    55101610131843: 40184301027391,
    55101723214211: 40184300929087,
    55101723246979: 40184300961855,
    55101723279747: 40184300994623,
    55101723312515: 40184301060159,
    55101723476355: 39429857017919,
    55101723509123: 39429857050687,
    55101723541891: 39429857083455,
    55101723574659: 40184304304191,
    55101723345283: 40184304205887,
    55101723378051: 40184304238655,
    55101723410819: 40184304271423,
    55101723443587: 40184304369727,
    55102141071747: 40184282742847,
    55102141104515: 40184282775615,
    56445404742019: 40184711839807,
    55156701069699: 40184719638591,
    55156681343363: 40184719900735,
    55156681376131: 40184719736895,
    55156694647171: 40184719966271,
    55156694679939: 40184719933503,
    55098435568003: 40184728354879,
    55087327674755: 40184723800127,
    55096997478787: 40078751563839,
    55096997511555: 40078751662143,
    55096997544323: 40078751694911,
    55096997577091: 40078751727679,
    55096872468867: 40247810818111,
    55096869847427: 40184287395903,
    55096869880195: 40184765743167,
    55096964022659: 40247807443007,
    55096964055427: 40184765841471,
    55096964088195: 40184765874239,
    55157824684419: 40184712396863,
    55157824717187: 40184712462399,
    55157824749955: 40184712888383,
    55156815561091: 40184292147263,
    55156815593859: 40184292180031,
    55156820935043: 40184290050111,
    55156820967811: 40184290639935,
    55156753006979: 40184298373183,
    55156727873923: 40184297291839,
    55156740522371: 40184298405951,
    55156598964611: 40184726028351,
    55156598997379: 40184725995583,
    55157797224835: 40184766234687,
    55098592788867: 39429865373759,
    55098592821635: 40184261279807
  };

  // Only attach checkout logic for US customers
  if (window.activeMarket !== 'US') {
    console.log("Customer is NOT in the USA ❌", window.customerCountry);
    return;
  }
  console.log("Customer is in the USA ✅");

  function getPartnerCartItems() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => cart.items
        .map(item => {
          const partnerId = partnerVariantMap[item.variant_id];
          return partnerId ? `${partnerId}:${item.quantity}` : null;
        })
        .filter(Boolean)
      );
  }

  // Checkout click handler
  function handleCheckoutClick(e) {
    const checkoutButton = e.target.closest('[name="checkout"], .cart__checkout');
    if (!checkoutButton) return;

    e.preventDefault();

    getPartnerCartItems().then(items => {
      if (items.length > 0) {
        // Redirect to partner checkout
        const url = `https://thefeed.com/?cart_ids=${items.join(',')}&checkout=1`;
        window.location.href = url;
      } else {
        // Fallback: normal Shopify checkout
        window.location.href = '/checkout';
      }
    });
  }

  // Capture all checkout buttons
  document.addEventListener('click', handleCheckoutClick);
});
*/